import { Component, OnInit, NgModule, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { RequiredItem } from '@vendasta/marketplace-apps/lib/_internal/objects/item';
import { NgForOf, NgIf } from '@angular/common';
import { DeliveryMethod, ItemType } from '@vendasta/marketplace-apps';
import { FormatDeliveryMethodPipe } from './format-delivery-method.pipe';
import { FormatItemTypePipe } from './format-item-type.pipe';

@Component({
  selector: 'sales-ui-app-item-card-v2',
  templateUrl: './item-card-v2.component.html',
  styleUrls: ['./item-card-v2.component.scss'],
  standalone: false,
})
export class ItemCardV2Component implements OnInit {
  @Input() itemId: string;
  @Input() defaultName: string;
  @Input() iconUrl: string;
  @Input() deliveryMethod: DeliveryMethod;
  @Input() ownerName: string;
  @Input() type: ItemType;
  @Input() requiredItems: RequiredItem[];

  requiredItemNames: string[];

  ngOnInit(): void {
    this.requiredItemNames = this.requiredItems?.map((item) => item.name);
  }

  protected readonly ItemType = ItemType;
}

@NgModule({
  declarations: [ItemCardV2Component],
  imports: [RouterLink, GalaxyAvatarModule, NgIf, NgForOf, FormatDeliveryMethodPipe, FormatItemTypePipe],
  exports: [ItemCardV2Component],
})
export class ItemCardV2ComponentModule {}
